
import { defineComponent } from 'vue'
import AsahiButton from '@/components/library/AsahiButton.vue'

export default defineComponent({
  name: 'ErrorModal',
  components: {
    AsahiButton
  },
  loadingIndicators: true,
  props: {
    errorMessages: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    hideCta: {
      type: Boolean,
      required: false,
      default: false
    },
    closeBtnLabel: {
      type: String,
      required: false,
      default: ''
    },
    showContinueBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    continueBtnLabel: {
      type: String,
      required: false,
      default: ''
    },
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  },
  methods: {
    continueModal () {
      this.closeModal()
      this.$emit('continueModal')
    }
  }

})
